/* eslint-disable no-console */
define((require, exports, module) => {
    'use strict';

    const getBase58Id = require('system/libs/getBase58Id');

    const xPageId = getBase58Id(8);

    try {
        console.log('x-page-id: ' + xPageId);
    } catch (reason) {
        // Do nothing
    }

    module.exports = xPageId;
});
